import { showAlert } from 'actions/client';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FetchAllOptionGroupsAPIRequest } from 'utils/constants/network';
import EditPen from 'utils/images/edit-pen.svg';
import { callAPI } from 'utils/network/index';
import { OPTION_GROUPS_MODALS } from '../../constants';
import {
  DispatchContext,
  StateContext,
} from '../../contexts/use-menu-editor-context';
import Button from '../shared/Button';
import { OptionGroupsToolTip } from '../shared/TooltipModals';
import OptionGroupModals from './option-group-modals';

const ListPadding = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 20px 30px;

  @media only screen and (max-width: 680px) {
    padding: 0px 10px 15px;
  }
`;

const ListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1120px;
  width: 100%;
  height: 70px;
  padding: 25px 20px 20px 30px;
  border-bottom: 1px #f3f3f3 solid;
  overflow: hidden;
  margin: 0 !important;
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

  h1 {
    font-size: 25px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const OptionGroupsHeader = styled.h1`
  margin-top: 26px;
  margin-bottom: 26px;
  margin-right: 2px;
  font-family: Geomanist;
  font-style: normal;
  font-weight: normal;
  line-height: 25px;
  letter-spacing: -0.4px;
  color: #000000;
`;

const ManageButton = styled(Button)`
  text-align: center;
  width: 99px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  border-radius: 28px;
  padding: 0 !important;
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.2px;
  font-size: 15px;

  :hover {
    border-color: #000;
  }
`;
const EditIcon = styled.img`
  width: 10px; // figma 9.23px;
  height: 10px; // figma 9.23px;
  margin-right: 6px;
`;

const OptionGroups = () => {
  // eslint-disable-next-line no-unused-vars
  const [fetchingOptionGroups, setFetchingOptionGroups] = useState(false);

  const {
    state: { optionGroups, isOgModalOpen, isManageMode },
  } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const handleModal = () => {
    dispatch({
      type: 'TOGGLE_OG_MODAL',
      payload: {
        isOgModalOpen: true,
      },
    });
    dispatch({
      type: 'SET_OG_MODAL_MODE',
      payload: {
        ogModalMode: OPTION_GROUPS_MODALS.LIST,
      },
    });

    dispatch({
      type: 'SET_GROUP_TO_EDIT',
      payload: {
        groupToEdit: {},
      },
    });

    dispatch({
      type: 'TOGGLE_IS_MANAGE_MODE',
      payload: {
        isManageMode: true,
      },
    });
  };

  const fetchAllOptionGroups = async () => {
    setFetchingOptionGroups(true);

    try {
      const apiRequest = FetchAllOptionGroupsAPIRequest({});
      const allOptionGroups = await callAPI(apiRequest);

      dispatch({
        type: 'UPDATE_OPTION_GROUPS',
        payload: {
          optionGroups: allOptionGroups,
        },
      });
    } catch (e) {
      console.error(e);
      showAlert('Failure', 'Sorry, we could not fetch your Groups.');
    } finally {
      setFetchingOptionGroups(false);
    }
  };

  useEffect(() => {
    fetchAllOptionGroups();
  }, []);

  return (
    <ListPadding>
      <ListContainer>
        <HeaderWrapper>
          <OptionGroupsHeader>Customisation Options</OptionGroupsHeader>
          <OptionGroupsToolTip />
        </HeaderWrapper>
        <ButtonWrapper>
          <ManageButton onClick={handleModal}>
            <EditIcon src={EditPen} alt="Edit" />
            Manage
          </ManageButton>
        </ButtonWrapper>
      </ListContainer>
      {Boolean(isOgModalOpen && isManageMode) && (
        <OptionGroupModals
          close={() => {
            dispatch({
              type: 'TOGGLE_OG_MODAL',
              payload: {
                isOgModalOpen: false,
              },
            });

            if (isManageMode) {
              dispatch({
                type: 'TOGGLE_IS_MANAGE_MODE',
                payload: {
                  isManageMode: false,
                },
              });
            }
          }}
          groups={optionGroups}
          allGroups={optionGroups}
          setGroups={newGroups =>
            dispatch({
              type: 'UPDATE_OPTION_GROUPS',
              payload: {
                optionGroups: newGroups,
              },
            })
          }
          fetchAllOptionGroups={fetchAllOptionGroups}
          isManageMode={isManageMode}
        />
      )}
    </ListPadding>
  );
};

export default OptionGroups;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/GlobalOptions/option-groups.jsx